import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import { isLoaded, isLoading, completedSubTasks } from "../actions";

export async function getSubTasksBySprint(dispatch, getUser, sprintId) {
    dispatch(isLoading());
    try {
      var response = await API.post("get_tasks.php", {
        "crop": getUser.corp,
        "action": "getsubtasksCompleted",
        "projectId": getUser.projectId,
        "userType": getUser.role,
        "empId": getUser.empId,
        "sprintId": sprintId
  
      }, {}, false);
      if (response.status === 'true') {
        // console.log(response)
        dispatch(completedSubTasks(response.data))
      }
      else {
        dispatch(completedSubTasks([]))
      }
    } catch (error) {
      Alert('error', error.message);
    }
    dispatch(isLoaded());
  }
  